/* Rundis theme: product page (variants, quantity tiers, gallery, sticky add-to-cart). */
(() => {
  'use strict';
  const T = window.Theme || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const setText = (root, sel, val) => $$(sel, root).forEach((el) => {
    el.textContent = val || '';
    if (el.hasAttribute('data-hide-empty')) (el.closest('[data-hide-wrap]') || el).hidden = !val;
  });

  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const json = $('[data-product-json]', this);
      this.data = json ? JSON.parse(json.textContent) : { variants: [] };
      this.formId = this.dataset.formId;
      this.variant = this.data.variants.find((v) => v.id === this.data.selected) || this.data.variants[0];
      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-input]')) this.onOptionChange();
        else if (e.target.matches('[data-tier-input]')) this.render();
      });
      this.setupSticky();
      this.render();
    }

    onOptionChange() {
      const picked = $$('[data-option-group]', this).map((g) => {
        const input = $('input:checked', g);
        return input ? input.value : null;
      });
      const v = this.data.variants.find((x) => x.options.every((o, i) => o === picked[i]));
      this.variant = v || null;
      $$('[data-option-group]', this).forEach((g, i) => {
        const label = $('[data-option-value]', g);
        if (label) label.textContent = picked[i] || '';
      });
      if (v) {
        $$('[data-variant-input]', this).forEach((input) => { input.value = v.id; });
        if (v.media_id) {
          const gallery = $('product-gallery', this);
          if (gallery) gallery.goToMedia(v.media_id);
        }
        if (this.dataset.updateUrl !== 'false') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      this.render();
      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v } }));
    }

    render() {
      const v = this.variant;
      const s = this.data.strings || {};
      const checked = $('[data-tier-input]:checked', this);
      const q = checked ? Number(checked.value) : 1;
      $$('[data-quantity-input]', this).forEach((el) => { el.value = q; });
      $$('[data-main-atc], [data-sticky-submit], [data-dc-wrapper] button', this).forEach((b) => {
        b.disabled = !v || !v.available;
      });
      if (!v) {
        setText(this, '[data-atc-label]', s.unavailable);
        return;
      }
      setText(this, '[data-price-current]', v.price);
      setText(this, '[data-price-compare]', v.compare);
      setText(this, '[data-price-save]', v.save);
      const tier = v.tiers.find((t) => t.q === q) || v.tiers[0];
      v.tiers.forEach((t) => {
        const card = $(`[data-tier-card="${t.q}"]`, this);
        if (!card) return;
        setText(card, '[data-tier-total]', t.total);
        setText(card, '[data-tier-unit]', t.unit);
        setText(card, '[data-tier-compare]', t.compare);
        setText(card, '[data-tier-save]', t.save);
      });
      if (!tier) return;
      setText(this, '[data-ship-line]', tier.ship);
      $$('[data-atc-label]', this).forEach((el) => {
        if (!v.available) el.textContent = s.soldOut;
        else el.textContent = el.hasAttribute('data-static-label') ? s.addToCart : tier.atc;
      });
      setText(this, '[data-sticky-price]', tier.total);
      setText(this, '[data-sticky-qty]', q > 1 ? tier.qlabel : '');
      setText(this, '[data-sticky-variant]', this.data.variants.length > 1 ? v.title : '');
    }

    setupSticky() {
      const bar = $('[data-sticky-atc]', this);
      const main = $('[data-main-atc]', this);
      if (!bar || !main || !('IntersectionObserver' in window)) return;
      const toggle = (show) => {
        bar.classList.toggle('is-visible', show);
        bar.toggleAttribute('inert', !show);
        bar.setAttribute('aria-hidden', String(!show));
      };
      new IntersectionObserver(([entry]) => {
        toggle(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(main);
      bar.addEventListener('click', (e) => {
        if (!e.target.closest('[data-sticky-submit]')) return;
        e.preventDefault();
        const form = document.getElementById(this.formId);
        if (form) form.requestSubmit();
      });
    }
  }
  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = $('[data-gallery-track]', this);
      if (!this.track) return;
      this.slides = $$('[data-gallery-slide]', this);
      this.index = 0;
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const nav = e.target.closest('[data-gallery-nav]');
        if (nav) { this.go(this.index + Number(nav.dataset.galleryNav)); return; }
        const pick = e.target.closest('[data-gallery-index]');
        if (pick) { this.go(Number(pick.dataset.galleryIndex)); return; }
        const zoom = e.target.closest('[data-zoom]');
        if (zoom) this.zoom(zoom);
        const toggle = e.target.closest('[data-video-toggle]');
        if (toggle) this.toggleVideo(toggle);
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.index - 1); }
      });
      this.setupVideos();
      this.sync();
    }

    go(i) {
      const n = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: this.slides[n].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    goToMedia(id) {
      const n = this.slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (n > -1) this.go(n);
    }

    sync() {
      const w = this.track.clientWidth || 1;
      const n = Math.round(this.track.scrollLeft / w);
      this.index = Math.max(0, Math.min(this.slides.length - 1, n));
      $$('[data-gallery-index]', this).forEach((el) => {
        const on = Number(el.dataset.galleryIndex) === this.index;
        el.setAttribute('aria-current', on ? 'true' : 'false');
      });
      const counter = $('[data-gallery-counter]', this);
      if (counter) counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      $$('[data-gallery-nav]', this).forEach((b) => {
        const dir = Number(b.dataset.galleryNav);
        b.disabled = (dir < 0 && this.index === 0) || (dir > 0 && this.index === this.slides.length - 1);
      });
      this.slides.forEach((s, i) => s.toggleAttribute('inert', i !== this.index && s.dataset.keepFocusable !== 'true'));
      this.playVisible();
    }

    zoom(btn) {
      const dialog = $('[data-lightbox]', this);
      if (!dialog) return;
      const img = $('img', dialog);
      img.src = btn.dataset.zoom;
      img.alt = btn.dataset.alt || '';
      T.openDialog(dialog, btn);
    }

    setupVideos() {
      this.videos = $$('video', this);
      this.videos.forEach((v) => {
        v.muted = true;
        v.playsInline = true;
        v.loop = true;
        if (reduceMotion) v.controls = true;
      });
    }

    playVisible() {
      if (reduceMotion || !this.videos) return;
      this.videos.forEach((v) => {
        const slide = v.closest('[data-gallery-slide]');
        const active = slide && this.slides.indexOf(slide) === this.index;
        if (active && !v.dataset.userPaused) {
          const p = v.play();
          if (p && p.catch) p.catch(() => {});
        } else {
          v.pause();
        }
        const btn = slide && $('[data-video-toggle]', slide);
        if (btn) btn.setAttribute('aria-pressed', String(v.paused));
      });
    }

    toggleVideo(btn) {
      const v = $('video', btn.closest('[data-gallery-slide]'));
      if (!v) return;
      if (v.paused) {
        delete v.dataset.userPaused;
        v.play();
      } else {
        v.dataset.userPaused = 'true';
        v.pause();
      }
      btn.setAttribute('aria-pressed', String(v.paused));
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
})();
